<template>
  <div class="divider"></div>
</template>

<script>
export default {
  name: "DividerComponent",
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.divider {
  width: 100%;
  height: 1px;
  background: $light-gray;
}
</style>
